var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFieldProLogoColour(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 536.17 140.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n.cls-1{fill=url(#linear-gradient);}\n.cls-2{fill:#020202;}\n"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -410.56,
    y1: 452.78,
    x2: -410.56,
    y2: 451.78,
    gradientTransform: "matrix(140.74, 0, 0, -140.89, 57852.73, 63790.68)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed883d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4672",
    "data-name": "Group 4672"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    fill: "url(#linear-gradient)",
    d: "M123.75,138,83.62,97.84a10,10,0,0,1,0-14.06h0a9.94,9.94,0,0,1,14.07,0h0l40.12,40.13a10,10,0,0,1,0,14.07h0a9.93,9.93,0,0,1-14.07,0ZM2.92,138a10,10,0,0,1,0-14.08L43,83.77A10,10,0,0,1,57.12,97.84h0L17,138a9.93,9.93,0,0,1-14.07,0ZM60.33,70.42a10,10,0,0,1,20.06,0h0a10,10,0,0,1-10,10h0a10,10,0,0,1-10-10Zm23.29-13.3a10,10,0,0,1,0-14.07h0L123.75,2.92a9.94,9.94,0,0,1,14.06,0h0a9.94,9.94,0,0,1,0,14.06h0L97.7,57.12a9.95,9.95,0,0,1-14.08,0ZM43,57.12,2.91,17A10,10,0,1,1,17,2.92L57.12,43a10,10,0,0,1,0,14.08h0a10,10,0,0,1-14.08,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4679",
    "data-name": "Group 4679"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_147152",
    "data-name": "Path 147152",
    className: "cls-2",
    d: "M179.47,51.36H172V45.83h7.47c.39-6.12,1.07-8.64,3.4-11.26,2.82-3.4,7.86-5.33,13.88-5.33h1.06v5.91a4.5,4.5,0,0,0-1-.1c-7.27,0-11.25,3.4-11.25,9.8v1h12.22v5.53H185.58v42.3h-6.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147153",
    "data-name": "Path 147153",
    className: "cls-2",
    d: "M204.51,29h6.11v11h-6.11Zm0,16.88h6.11V93.66h-6.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147154",
    "data-name": "Path 147154",
    className: "cls-2",
    d: "M226.73,72c.48,9.51,8.92,17.27,18.72,17.27A18.74,18.74,0,0,0,262,78h6.7A25.11,25.11,0,1,1,267.19,58c2,3.79,2.81,7.38,3,14.07Zm37-5.53c-1.16-4.75-2.71-7.86-5.53-10.77a18.77,18.77,0,0,0-12.71-5.53c-9.21,0-16.88,6.7-18.53,16.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147155",
    "data-name": "Path 147155",
    className: "cls-2",
    d: "M279.81,29h6.11V93.66h-6.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147156",
    "data-name": "Path 147156",
    className: "cls-2",
    d: "M346.17,93.66h-5.82V85c-2.62,3.49-4.46,5.24-7.28,6.89a25.23,25.23,0,0,1-11.45,2.91c-14.55,0-25.9-11.06-25.9-25.23,0-13.87,11.45-24.93,25.81-24.93a23.52,23.52,0,0,1,18.53,8.73V29h6.11ZM301.83,69.5c0,10.77,8.74,19.8,19.31,19.8s19.11-8.83,19.11-19.8a19.21,19.21,0,0,0-38.42-.27v.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147157",
    "data-name": "Path 147157",
    className: "cls-2",
    d: "M358,29h21.15c10.28,0,15.52,1.26,19.89,4.75,4.75,3.88,7.56,10.28,7.56,17.17a23.38,23.38,0,0,1-6.79,16.88c-4.27,4-9.7,5.63-18.92,5.63h-7.08V93.66H358Zm22.5,29.78c4,0,6.12-.48,7.76-1.84A7.73,7.73,0,0,0,388.8,46a8.72,8.72,0,0,0-1-.92c-1.55-1.07-4-1.55-8-1.55h-6V58.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147158",
    "data-name": "Path 147158",
    className: "cls-2",
    d: "M414.1,29h20.48c10.76,0,15.52,1.06,19.88,4.65a23,23,0,0,1,8,17.66,21,21,0,0,1-7.08,16.3c-2.72,2.42-4.95,3.39-9,4.07l17.56,22H445l-15-21v21H414.1Zm21.64,32.5c3.49,0,5.63-.59,7.47-2a9,9,0,0,0,3.4-7c0-5.82-3.69-8.92-10.67-8.92h-6v18Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147159",
    "data-name": "Path 147159",
    className: "cls-2",
    d: "M536.17,61.26c0,18.82-15,33.66-34,33.66-19.6,0-34.25-14.55-34.25-34.05,0-18.63,15-33.19,34.25-33.19C521.13,27.68,536.17,42.52,536.17,61.26Zm-51.81-.1c0,10.86,7.67,19.21,17.76,19.21s17.56-8.25,17.56-19.21c0-10.58-7.76-18.93-17.56-18.93-10.19,0-17.75,8.16-17.75,18.93Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4794",
    "data-name": "Group 4794"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_147123",
    "data-name": "Path 147123",
    className: "cls-2",
    d: "M313.44,112.22H319a7.75,7.75,0,0,1,5.08,1.45,5.72,5.72,0,0,1,2.12,4.42,5.22,5.22,0,0,1-2.41,4.43,5.66,5.66,0,0,1,3.66,5.51,5.94,5.94,0,0,1-2.6,4.91c-1.45,1-2.78,1.29-5.85,1.29h-5.54Zm5,9.5a7,7,0,0,0,3.76-.66A3.61,3.61,0,0,0,324,118a3.85,3.85,0,0,0-1.45-2.87,6.24,6.24,0,0,0-3.93-.92h-2.93v7.52Zm.3,10.53a10,10,0,0,0,4.12-.59,4.26,4.26,0,0,0,2.38-3.63,4.06,4.06,0,0,0-2.57-3.83,11,11,0,0,0-4.29-.5h-2.71v8.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147124",
    "data-name": "Path 147124",
    className: "cls-2",
    d: "M335.61,133.7,329.27,118h2.41l5.15,13,5.54-13h2.35l-9.44,22H333Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147125",
    "data-name": "Path 147125",
    className: "cls-2",
    d: "M378.32,123.24a11.5,11.5,0,1,1-11.55-11.45h.07a11.45,11.45,0,0,1,11.48,11.42Zm-18.94,0a7.44,7.44,0,1,0,7.42-7.69,7.56,7.56,0,0,0-7.42,7.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147126",
    "data-name": "Path 147126",
    className: "cls-2",
    d: "M382,112.22h4.62l9.18,16v-16h4.05v22h-4.55l-9.24-16v16H382Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147127",
    "data-name": "Path 147127",
    className: "cls-2",
    d: "M409.57,126.11l-7.23-13.89h4.46l4.82,10.13,4.78-10.13h4.49l-7.26,13.89v8.12h-4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147128",
    "data-name": "Path 147128",
    className: "cls-2",
    d: "M428.71,123.27l-7.59-11h4.82l5.15,7.69,5.28-7.69h4.75l-7.63,11,7.63,11h-4.76l-5.28-7.62-5.15,7.62h-4.81Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4795",
    "data-name": "Group 4795"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_147232",
    "data-name": "Path 147232",
    className: "cls-2",
    d: "M451.73,134.63v-20.5h3.8v20.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147233",
    "data-name": "Path 147233",
    className: "cls-2",
    d: "M469,134.63V127c0-2.14-.36-4.93-3.1-4.93a3.17,3.17,0,0,0-2.52,1.35c-.67,1-.67,2.72-.67,3.86v7.31H459V119.25h3.41v1.33a5.6,5.6,0,0,1,4.21-1.85,6.26,6.26,0,0,1,4.62,2.13,8.12,8.12,0,0,1,1.42,5.23v8.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147234",
    "data-name": "Path 147234",
    className: "cls-2",
    d: "M480.41,135.12a5.87,5.87,0,0,1-4.6-2,5.78,5.78,0,0,1-1.16-3.32h3.77c.25,1.11.74,2,2,2a1.58,1.58,0,0,0,1.66-1.49v-.06a1.38,1.38,0,0,0-.22-.8c-.5-.7-2.47-1.23-3.24-1.5-2.05-.73-3.44-2.14-3.44-4.4a5,5,0,0,1,5.15-4.77h0a4.93,4.93,0,0,1,5,4.71h-3.6a1.45,1.45,0,0,0-1.47-1.33,1.34,1.34,0,0,0-1.41,1.28v0c0,.8.64,1,1.27,1.27.45.17.89.31,1.33.45,2.38.74,4.29,1.74,4.29,4.6a5.26,5.26,0,0,1-5.18,5.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147235",
    "data-name": "Path 147235",
    className: "cls-2",
    d: "M487.79,117.51v-3.38h3.68v3.38Zm0,17.12V119.25h3.68v15.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147236",
    "data-name": "Path 147236",
    className: "cls-2",
    d: "M505.3,140.17a9,9,0,0,1-3.47.72,8.09,8.09,0,0,1-7.72-5.1h4.21a4.65,4.65,0,0,0,3.79,1.71,4.73,4.73,0,0,0,4.71-4.77v0l-.05-.05a5.89,5.89,0,0,1-5,2.46,7.11,7.11,0,0,1-3-.69,8.22,8.22,0,0,1-4.82-7.64,8,8,0,0,1,7.83-8.06,5.66,5.66,0,0,1,4.9,2.41h.06v-1.89h3.57V131.8C510.23,135.48,508.82,138.7,505.3,140.17ZM502,122.11a4.56,4.56,0,0,0-4.49,4.65v.06a4.72,4.72,0,0,0,4.5,4.92h.1c2.69,0,4.4-2.44,4.4-5A4.68,4.68,0,0,0,502,122.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147237",
    "data-name": "Path 147237",
    className: "cls-2",
    d: "M522.7,134.63v-7.87c0-2.22-.36-4.65-3.15-4.65s-3.1,2.57-3.1,4.7v7.82h-3.69v-20.5h3.69v6.2a5.44,5.44,0,0,1,4-1.6,6.3,6.3,0,0,1,4.74,2.35,7.49,7.49,0,0,1,1.22,4.62v8.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147238",
    "data-name": "Path 147238",
    className: "cls-2",
    d: "M534,122.52v12.11h-3.69V122.52h-1.8v-3.27h1.8v-5.12H534v5.12h2.21v3.27Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldProLogoColour);
export default __webpack_public_path__ + "static/media/FieldPRO_Logo_Colour.7f5063ae4578fd5be9a5085df5ae78c7.svg";
export { ForwardRef as ReactComponent };